import React from "react";

import { PromoColumnsBlock } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { VideoChooserBlock } from "@thelabnyc/thelabui/src/components/VideoChooserBlock";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { LongButton } from "../Clickables";
import { H, HLevel } from "../Headings";
import { RichText } from "../RichText";
import { ThemedModule, getThemeClass } from "../ThemedModule";

import styles from "./PromoColumns.module.scss";

export const PromoColumns = (props: { value: PromoColumnsBlock }) => {
    if (!props.value.columns) return;

    return (
        <ThemedModule theme={props.value.module_theme}>
            <div
                className={concatClassNames([
                    styles.root,
                    props.value.columns.length === 1 ? styles.single : "",
                ])}
            >
                {props.value.columns.map(({ id, value }) => (
                    <HLevel key={id}>
                        <article
                            className={concatClassNames([
                                styles.column,
                                getThemeClass(props.value.theme),
                            ])}
                        >
                            {value.media &&
                                value.media.map(({ type, value, id }) => {
                                    switch (type) {
                                        case "image":
                                            return (
                                                <ImageChooserBlock
                                                    key={id}
                                                    attrs={{
                                                        className: styles.media,
                                                    }}
                                                    value={value}
                                                />
                                            );
                                        case "video":
                                            return (
                                                <VideoChooserBlock
                                                    key={id}
                                                    attrs={{
                                                        className: styles.media,
                                                    }}
                                                    value={value}
                                                />
                                            );
                                        default:
                                            return null;
                                    }
                                })}
                            <div className={styles.textWrapper}>
                                {value.eyebrow && (
                                    <p className={styles.eyebrow}>
                                        {value.eyebrow}
                                    </p>
                                )}
                                {value.heading && (
                                    <H className={styles.heading}>
                                        {value.heading}
                                    </H>
                                )}
                                {value.subhead && (
                                    <p className={styles.subhead}>
                                        {value.subhead}
                                    </p>
                                )}
                                <div style={{ flex: 1 }} />
                                {value.body && <RichText value={value.body} />}
                                {value.cta?.display_name && (
                                    <LongButton
                                        variant="primary"
                                        className={styles.cta}
                                        simpleLink={value.cta}
                                    >
                                        {value.cta.display_name}
                                    </LongButton>
                                )}
                            </div>
                        </article>
                    </HLevel>
                ))}
            </div>
        </ThemedModule>
    );
};
